var _path, _clipPath, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAppKairos(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1024,
    height: 1024,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    transform: "translate(512 895)",
    d: "M0 -91.5C228.922 -91.5 414.5 -50.5341 414.5 0C414.5 50.5341 228.922 91.5 0 91.5C-228.922 91.5 -414.5 50.5341 -414.5 0C-414.5 -50.5341 -228.922 -91.5 0 -91.5Z"
  })), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "cl_3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M511.848 0C740.77 0 1024 0 926.5 895.25C926.5 946.198 740.922 987.5 512 987.5C283.078 987.5 97.5 946.198 97.5 895.25C-6.10352e-05 0 282.926 0 511.848 0Z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cl_3)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#191919",
    transform: "matrix(1.32982 0 0 2.92994 524 832.935)",
    d: "M0 -58.1883C56.196 -58.1883 84 -71.6548 84 23.195C84 61.5788 53.7534 75.0119 0 69.5C-50.2971 71.0886 -84 69.5 -84 23.195C-80.5596 -71.6548 -43.2416 -58.1883 0 -58.1883Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#191919",
    transform: "matrix(1.32982 0 0 1.32982 524 576.897)",
    d: "M-0.25 -142.5C90.7389 -142.5 164.5 -86.3984 164.5 26.4772C164.5 112.798 90.7389 142.5 -0.25 142.5C-91.2389 142.5 -164.794 112.798 -164.794 26.4772C-164.794 -86.3984 -91.2389 -142.5 -0.25 -142.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#191919",
    transform: "matrix(-1.46695 -0.14875 0.14875 -1.46695 647.887 376.775)",
    d: "M-37.4863 -113.677C3.08084 -152.913 88.8857 -159.465 65.5182 -38.3502C-39.1454 26.8651 158.563 141.85 77.757 174.198C27.253 194.416 -52.0242 136.685 -70.1346 15.9547C-80.262 -36.3483 -74.0757 -75.7589 -37.4863 -113.677Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#191919",
    transform: "matrix(-1.44464 0.295099 -0.295099 -1.44464 416.94 444.169)",
    d: "M-37.4863 -113.677C3.08085 -152.913 88.8857 -159.465 65.5182 -38.3502C-39.1454 26.8651 158.563 141.85 77.757 174.198C27.253 194.416 -52.0242 136.685 -70.1346 15.9547C-80.262 -36.3483 -74.0757 -75.7589 -37.4863 -113.677Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    transform: "matrix(1.15581 0.100284 -0.100284 1.15581 417.515 575.389)",
    d: "M0.749999 -101C49.4345 -101 75 -55.445 75 0.750015C75 73.4476 41.7571 102.5 0.750001 102.5C-44.6028 102.5 -73.5 73.4476 -73.5 0.750016C-73.5 -55.445 -41.7529 -101 0.749999 -101Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#191919",
    transform: "matrix(0.678742 0.0588908 -0.0588908 0.678742 412.163 576.672)",
    d: "M0.75 -101C49.4345 -101 75 -55.445 75 0.75C75 73.4476 41.7571 102.5 0.75 102.5C-44.6028 102.5 -73.5 73.4476 -73.5 0.75C-73.5 -55.445 -41.7529 -101 0.75 -101Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    transform: "matrix(-1.15579 0.100285 0.100287 1.15581 636.137 576.52)",
    d: "M0.749969 -101C49.4345 -101 75 -55.445 75 0.75C75 73.4476 41.7571 102.5 0.749969 102.5C-44.6029 102.5 -73.5 73.4476 -73.5 0.75C-73.5 -55.445 -41.753 -101 0.749969 -101Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#191919",
    transform: "matrix(-0.678727 0.0588915 0.0588928 0.678742 641.489 577.802)",
    d: "M0.750001 -101C49.4345 -101 75 -55.445 75 0.75C75 73.4476 41.7571 102.5 0.749999 102.5C-44.6028 102.5 -73.5 73.4476 -73.5 0.75C-73.5 -55.445 -41.7529 -101 0.750001 -101Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppKairos);
export default __webpack_public_path__ + "static/media/appKairos.cdeeb7c874aa487e6a8bb3a9ad5b2e94.svg";
export { ForwardRef as ReactComponent };